import React, { lazy, Suspense } from 'react';
export var JIRA_LIST_OF_LINKS_DATASOURCE_ID = 'd8b75300-dfda-4519-b6cd-e49abbd50401';
var LazyJiraIssuesConfigModal = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_linkdatasource-jiraissuesmodal" */'./modal').then(function (module) {
    return {
      default: module.JiraIssuesConfigModal
    };
  });
});
var JiraIssuesConfigModalWithWrappers = function JiraIssuesConfigModalWithWrappers(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      "data-testid": 'jira-datasource-table-suspense'
    })
  }, /*#__PURE__*/React.createElement(LazyJiraIssuesConfigModal, props));
};
export default JiraIssuesConfigModalWithWrappers;